import { useStore } from 'effector-react';
import { MixItem } from '../../../../../common/components/mix-item';
import styles from './index.module.sass';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import {
  $topRecipesForWarehouse,
  $topRecipesLoading,
  fetchTopRecipesForWarehouse,
  fetchWarehousesForMixingDataFx,
} from '@/widgets/recipe/model';
import { ILeftoverBag } from '@/widgets/recipe/types';
import { LeftoverItem } from './components/leftover-item';
import { cancelTradeOffer } from '@/modules/mixing/helpers/dalete-offer.helper';
import { $selectedRecipeStore } from '@/modules/mixing/store/recipes.store';
import useScrollRestoration from '@/shared/hooks/useScrollRestoration';
import { getBestMarketPricesFx } from '@/modules/mixing/store/analytical-mixing.store';

export const LeftoversList = ({
  selectRecipeFoo,
  leftoversList,
}: {
  selectRecipeFoo: (id: number) => void;
  leftoversList: ILeftoverBag[] | [];
}) => {
  const fetchStatus = useStore($topRecipesLoading);
  const activeWh = useStore($selectedRecipeStore);
  const isStationary = activeWh?.type === '1';
  const topData = useStore($topRecipesForWarehouse);

  const saveScrollPosition = useScrollRestoration(!fetchStatus.loading, 'contentAreaScrollable');

  return (
    <div className={styles.root} id="contentAreaScrollable">
      {!fetchStatus.loading ? (
        leftoversList ? (
          leftoversList.map((item, i) => (
            <>
              <LeftoverItem
                data={item}
                id={item.bag}
                weight={item.weight}
                weightGain={item.weight_gain_tons}
                params={item.values}
                culture="Пшеница"
                type={item.type}
                sort={item.sort}
                saveScrollPosition={saveScrollPosition}
                classN={String(item.class).replace(/\D/g, '')}
                isStationary={isStationary}
                action={
                  //undefined
                  item.trade_id
                    ? {
                        type: 'busy',
                        onClick: () => {
                          cancelTradeOffer(
                            Number(item.trade_id),
                            async () => {
                              if (activeWh) await fetchTopRecipesForWarehouse(Number(activeWh.id)),
                              await fetchWarehousesForMixingDataFx({});
                              await getBestMarketPricesFx(true);
                            },
                            isStationary,
                            topData?.mix_signature,
                          );
                        },
                      }
                    : item.buyer_company
                    ? { type: 'sell', onClick: () => {} }
                    : undefined
                }
                targetHumidity={{ weight: item.weight, humidity: item.offer_humidity }}
                offer={{
                  logisticPriceTkm: item.freight_cost_tkm,
                  buyer: item.buyer_company,
                  priceTon: item.price_per_ton,
                  priceLogistic: item.price_logistic,
                  priceLogisticInitial: item.initial_price_logistic,
                  distance: item.distance,
                  sleevePrice: item.all_price,
                  sleevePriceNetto: item.price_netto,
                  freight_cost_after_moisture_mod: item.freight_cost_after_moisture_mod,
                  freight_cost_before_moisture_mod: item.freight_cost_before_moisture_mod,
                }}
                leftoverTooltip={{
                  components: {
                    weight: [item.initial_weight, item.mix_weight],
                    price: [item.initial_price, item.mix_price],
                    price_per_ton: [item.price_per_ton, item.price_per_ton],
                    buyer: [item.buyer_company, item.buyer_company],
                    logit_price: [item.initial_price_logistic, item.mix_price_logistic],
                    distance: [222, 333],
                    nett_price: [item.initial_price_netto, item.mix_price_netto],
                  },
                }}
              />
              {/* <MixItem
              key={i}
              mode='leftover'
              idx={item.bag}
              onClick={() => selectRecipeFoo(0)}
              type="мягкая белозерная яровая"
              wheatClass={item.class}
              weight={item.weight}
              price={item.all_price}
              distance={item.distance}
              //componentPrice={0}
              logitPrice={item.price_logistic}
              profit={item.price_netto}
              pricePerTon={item.price_per_ton}
              buyer={item.buyer_company} nettPrice={0} sort={''} 
              leftoverTooltip={{ components: {
                weight: [item.initial_weight, item.mix_weight],
                price: [item.initial_price, item.mix_price],
                price_per_ton: [item.price_per_ton, item.price_per_ton],
                buyer: [item.buyer_company, item.buyer_company],
                logit_price: [item.initial_price_logistic, item.mix_price_logistic],
                distance: [222, 333],
                nett_price: [item.initial_price_netto, item.mix_price_netto],
              } }}
              /> */}
            </>
          ))
        ) : (
          <div className={styles.filler}>
            {' '}
            <span>рецепты не найдены</span>
          </div>
        )
      ) : (
        <UniversalLoader error={fetchStatus.error} />
      )}
    </div>
  );
};
